import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 8px;
	width: 100%;
`;

export const AreaButtons = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
`;
